import scrollToElement from 'scroll-to-element';

import { DURATION } from '../config.js';
import { showPreloader, hidePreloader } from '../preloader.js';

const anchorLinks = document.querySelectorAll('.anchor-links a, .anchor');

anchorLinks?.forEach(link => {
  link.addEventListener('click', event => {
    if (window.innerWidth > 960) return;

    const href = link.getAttribute('href');

    if (!href || !href.startsWith('#') || href === '#') return;

    event.preventDefault();

    const header = document.querySelector('.header');
    const headerHeight = header?.offsetHeight || 0;

    const targetElement = document.querySelector(href);

    if (targetElement) {
      showPreloader();

      scrollToElement(targetElement, {
        offset: -headerHeight,
        ease: 'inOutQuint',
        duration: DURATION,
      });

      setTimeout(() => {
        hidePreloader();
      }, DURATION);
    } else {
      const scrollOffset = headerHeight;
      const pathParts = window.location.pathname.split('/');
      const langPrefix =
        pathParts[1] && pathParts[1].length === 2 ? `/${pathParts[1]}` : '';
      window.location.href = `${langPrefix}/${href}?offset=${scrollOffset}`;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 960) return;

  const fullHash = window.location.hash;
  if (!fullHash) return;

  const [hashOnly, queryString] = fullHash.split('?');
  const targetElement = document.querySelector(hashOnly);
  if (!targetElement) return;

  const params = new URLSearchParams(queryString || '');
  const offset = parseInt(params.get('offset') || '0', 10);

  scrollToElement(targetElement, {
    offset: -offset,
    ease: 'inOutQuint',
    duration: 1000,
  });

  const pathParts = window.location.pathname.split('/');
  const langPrefix =
    pathParts[1] && pathParts[1].length === 2 ? `/${pathParts[1]}` : '';
  history.replaceState(null, '', langPrefix + '/');
});
